import NextLink from 'next/link'
import React from 'react'
import styled from 'styled-components'
import { MaxWidthContainer } from 'lib/Section'
import { Text } from 'lib/Text'
import { Page } from 'modules/Page'
import { CategoryTable } from 'modules/brands/discovery/CategoryTable'

const Container = styled(MaxWidthContainer)`
  margin-bottom: 24px;
  margin-top: 48px;
  padding: 0 var(--box-padding);
  text-align: center;
`

const Content = styled.nav`
  margin: var(--spacing) 0;
`

const BackLink = styled(Text).attrs({ size: 'pxs', weight: 'semi' })`
  color: var(--black-60);
  cursor: pointer;
  display: flex;
  margin: 10px 0;
  position: relative;
  text-decoration: none;
  width: max-content;

  &:hover {
    color: var(--black-80);
  }

  &::before {
    content: '←';
    margin-right: 4px;
  }

  &::after {
    display: none;
  }
`

const CategoryListPage = () => (
  <Container>
    <Text weight="bold" size="xl" as="h1">
      Categories
    </Text>
    <NextLink href="/brands" passHref>
      <BackLink as="a">Back</BackLink>
    </NextLink>
    <Content>
      <CategoryTable />
    </Content>
  </Container>
)

CategoryListPage.getLayout = function getLayout(page: React.ReactElement) {
  return <Page meta={{ title: 'All Categories', description: 'Search all categories on Thingtesting.' }}>{page}</Page>
}

export default CategoryListPage
